export default __webpack_public_path__ + "fec8e144d0c7dbc9e4c7202c0551c620.webp";